import { SET_SHOW_ART_WALL_CLEAR_ALL_MODAL } from '../const';

export default (showArtWallClearAllModal) => {
  return {
    type: SET_SHOW_ART_WALL_CLEAR_ALL_MODAL,
    showArtWallClearAllModal: showArtWallClearAllModal
  }
};
